import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { APIURLs } from '../api-urls';
import { map, catchError } from 'rxjs/operators';
import { SharedService } from '../shared/shared.service';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../api-urls";
import * as i3 from "../shared/shared.service";
/** Service Injectable */
var OnboardingService = /** @class */ (function () {
    /**
     * Method to initialize Component
     * @param http  Sends an `HTTPRequest` and returns a stream of `HTTPEvents`.
     * @param urls Getting  apiurl from API url Component
     * @param shared shared Service Component
     */
    function OnboardingService(http, urls, shared) {
        this.http = http;
        this.urls = urls;
        this.shared = shared;
        this.kycLoader = false;
    }
    /** show loader */
    OnboardingService.prototype.showLoader = function (message) {
        //  console.log("show loader called")
        this.shared.loadingMessage = (message ? message.split('.').join('') : "") || "";
        this.shared.isServiceHit = true;
    };
    /** Hide Loader */
    OnboardingService.prototype.hideLoader = function () {
        if (this.kycLoader == false) {
            this.shared.loadingMessage = "";
            this.shared.isServiceHit = false;
        }
    };
    /**
  * Fetches encrypted Data from the server.
  * @param {any} request - The request object containing investor details.
  * @returns {Observable<any>} An observable that emits the server's response or an error.
  */
    OnboardingService.prototype.encryptData = function (request) {
        var _this = this;
        var url = this.urls.getEncryptURL();
        this.showLoader("Saving your details..");
        return this.http.post(url, request, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
* Fetches decrypted Data from the server.
* @param {any} request - The request object containing investor details.
* @returns {Observable<any>} An observable that emits the server's response or an error.
*/
    OnboardingService.prototype.decryptData = function (request) {
        var _this = this;
        var url = this.urls.getDecryptURL();
        this.showLoader("Fetching details..");
        return this.http.post(url, request, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Fetches check For Existence Data from the server.
     * @param {any} request - The request object containing investor details.
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.checkForExistence = function (request) {
        var _this = this;
        var url = this.urls.getCheckExistenceURL();
        var payload = {
            PAN: request.PAN,
            mobile: null,
            clientId: request.clientId,
            both: request.both
        };
        this.showLoader("Checking if already exist..");
        return this.http.post(url, payload, { headers: this.getHeaders(false, request.investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
    * Fetches investor Data from the server.
    * @param {any} request - The request object containing investor details.
    * @returns {Observable<any>} An observable that emits the server's response or an error.
    */
    OnboardingService.prototype.getInvestorById = function (investorId) {
        var _this = this;
        var url = this.urls.getInvestorByIdURL(investorId);
        this.showLoader("Fetching details..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
    * Fetches investor details from the server.
    * @param {any} request - The request object containing investor details.
    * @returns {Observable<any>} An observable that emits the server's response or an error.
    */
    OnboardingService.prototype.getInvestorDetails = function (request) {
        var _this = this;
        /** URL for fetching investor details */
        var url = this.urls.getInvDetailsURL();
        /** Displays loader while fetching investor details */
        this.showLoader("Fetching details..");
        /** Sends an HTTP POST request to fetch the investor details */
        return this.http.post(url, request, { headers: this.getHeaders() }).pipe(map(function (response) {
            /** Hides loader on successful response */
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            /** Hides loader on error and rethrows the error */
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Fetches investor details from the server.
     * @param request - The request object containing investor details.
     * @param isForceProcess passing value of force process
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.registerInvestor = function (request, isForceProcess) {
        var _this = this;
        var url = this.urls.getRegisterInvestorURL(isForceProcess);
        this.showLoader("Registering..");
        return this.http.post(url, request, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Fetches CVL from the server.
     * @param request  - The request object containing investor details.
     * @param investorId -passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.fetchFromCVL = function (request, investorId) {
        var _this = this;
        var url = this.urls.getPANDetailsURL();
        this.showLoader("Fetching from CVL..");
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Fetches city from the server.
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveLeadCityList = function () {
        var url = this.urls.getLeadCityListURL();
        this.showLoader("Retrieving city list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            // this.hideLoader(); 
            return response;
        }), catchError(function (error) {
            // this.hideLoader(); 
            return throwError(error);
        }));
    };
    /**
     * fetch city name from server
     * @param cityname passing city name
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveLeadCityListV2 = function (cityname) {
        var _this = this;
        var url = this.urls.getLeadCityListURLV2(cityname);
        this.showLoader("Retrieving city list..");
        return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetch investor detail from server
     * @param request - The request object containing investor details.
     * @param investorId - passing investor id
     * @param hideLoader -for loader
     * @param contactUpdationType - contact updation time
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.updateInvestor = function (request, investorId, hideLoader, contactUpdationType) {
        var _this = this;
        var url = this.urls.getUpdateInvDetailsURL();
        if (!hideLoader) {
            this.showLoader("Saving your details..");
        }
        return this.http.post(url, request, { headers: contactUpdationType ? this.getcontactUpdationTypeHeaders(false, investorId, '', false, contactUpdationType) : this.getHeaders(false, investorId, '', false) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * delete investor detail from server
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.deleteInvestor = function (investorId) {
        var _this = this;
        var url = this.urls.getDeleteInvestorURL(investorId);
        this.showLoader("Saving your details..");
        return this.http.delete(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     *  delete client from server
     * @param clientId passing client id
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.deleteClient = function (clientId, investorId) {
        var _this = this;
        var url = this.urls.getDeleteClientIdURL(clientId);
        this.showLoader("");
        return this.http.delete(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * recover investor detail
     * @param pan passing pan number
     * @param mobileNumber passing mobile number
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.recoverInvestor = function (pan, mobileNumber, investorId) {
        var _this = this;
        var url = this.urls.getRecoverAccountURL(pan, mobileNumber);
        this.showLoader("Recovering information..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * send otp
     * @param pan passing pan number
     * @param investorId passing innvestor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.sendOTP = function (pan, investorId) {
        var _this = this;
        var url = this.urls.getSendOTPURL(pan);
        this.showLoader("Sending OTP..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     *  validate OTP
     * @param otp  passing otp
     * @param newInvestorId passing investor id
     * @param pan passing pan number
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.validateOTP = function (otp, newInvestorId, pan, investorId) {
        var _this = this;
        var url = this.urls.getValidateOTPURL(otp, newInvestorId, pan);
        this.showLoader("Validating OTP..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching investor port
     * @param request
     * @param investorId
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.portInvestor = function (request, investorId) {
        var _this = this;
        var url = this.urls.getPortingURL();
        this.showLoader("Porting detail..");
        return this.http.post(url, request, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching bank listing
     * @param flag passing flag value
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveBankLists = function (flag) {
        var _this = this;
        var url = this.urls.getBankListURL();
        this.showLoader(flag ? "Retrieving bank details.." : "Retrieving bank list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching bank detail
     * @param ifsc passing ifsc value
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveBankDetails = function (ifsc) {
        var _this = this;
        var url = this.urls.getBankDetailsURL(ifsc);
        this.showLoader("Retrieving bank details..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching branch list
     * @param bank  passing bank name
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveBranchLists = function (bank) {
        var _this = this;
        var url = this.urls.getBranchListURL(bank);
        this.showLoader("Retrieving branch list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching state nAME
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveStateLists = function () {
        var url = this.urls.getStateListURL();
        this.showLoader("Retrieving state list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            // this.hideLoader(); 
            return response;
        }), catchError(function (error) {
            // this.hideLoader(); 
            return throwError(error);
        }));
    };
    /**
     * FETCHING EDUCATION LIST
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveEducationLists = function () {
        var _this = this;
        var url = this.urls.getEducationListURL();
        this.showLoader("Retrieving education list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching screen list
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveScreenLists = function () {
        var url = this.urls.getScreenListURL();
        this.showLoader("Retrieving screen list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            // this.hideLoader(); 
            return response;
        }), catchError(function (error) {
            // this.hideLoader(); 
            return throwError(error);
        }));
    };
    /**
     * update onboarding screen naME
     * @param request passing screen name
     * @param inverstorId passing investor id
     * @param hideLoader passing loader
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.updateOnboardingScreen = function (request, inverstorId, hideLoader) {
        var _this = this;
        var url = this.urls.getUpdateScreenURL();
        if (!hideLoader) {
            //this.showLoader("Updating screen data..");
            this.showLoader("");
        }
        return this.http.post(url, request, { headers: this.getHeaders(false, inverstorId || '') }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching occupation list
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveOccupationLists = function () {
        var url = this.urls.getOccupationListURL();
        // this.showLoader("Retrieving occupation list.."); 
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            // this.hideLoader(); 
            return response;
        }), catchError(function (error) {
            // this.hideLoader(); 
            return throwError(error);
        }));
    };
    /**
     * retrieve IncomeSlab Lists
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveIncomeSlabLists = function () {
        var _this = this;
        var url = this.urls.getIncomeSlabListURL();
        this.showLoader("Retrieving income slab list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * retrieve Country Lists
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveCountryLists = function () {
        var url = this.urls.getCountryListURL();
        this.showLoader("Retrieving country list..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            // this.hideLoader(); 
            return response;
        }), catchError(function (error) {
            // this.hideLoader(); 
            return throwError(error);
        }));
    };
    /**
     * generate IPV OTP
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.generateIPVOTP = function (investorId) {
        var _this = this;
        var url = this.urls.getIPVOTPURL();
        this.showLoader("Generating IPV OTP..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * upload IPV
     * @param formData passing form Data
     * @param fileName passing file name
     * @param investorId passing investor id
     * @param hideLoader passing loader
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.uploadIPV = function (formData, fileName, investorId, hideLoader) {
        var _this = this;
        var url = this.urls.getUploadIPVURL(fileName);
        if (!hideLoader) {
            this.showLoader("Uploading IPV..");
        }
        return this.http.post(url, formData, { headers: this.getHeaders(false, investorId, null, true) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * update Onboarding Completion
     * @param isEsignFlag passing Esign flag
     * @param investorId  passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.updateOnboardingCompletion = function (isEsignFlag, investorId) {
        var _this = this;
        var url = this.urls.getOnboardCompleteURL(isEsignFlag);
        this.showLoader("Completing onboarding..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching Document
     * @param formData passing form Data
     * @param fileName passing file name
     * @param documentType passing document type
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.uploadDoc = function (formData, fileName, documentType, investorId) {
        var _this = this;
        var url = this.urls.getUploadDocURL(fileName, documentType);
        this.showLoader("Uploading documents..");
        return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * upload Documet
     * @param formData passing form data
     * @param fileNames passing file name
     * @param documentTypes passing document type
     * @param investorId passing investor id
     * @param hideLoader passing loader
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.uploadDocs = function (formData, fileNames, documentTypes, investorId, hideLoader) {
        var _this = this;
        var url = this.urls.getUploadDocsURL(fileNames, documentTypes);
        if (!hideLoader) {
            this.showLoader("Uploading documents..");
        }
        return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * upload AOF Docs
     * @param formData passing Form data
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.uploadAOFDocs = function (formData, investorId) {
        var _this = this;
        var url = this.urls.getUploadAofURL();
        this.showLoader("Uploading AOF documents..");
        return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * delete Nominee
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.deleteNominee = function (investorId) {
        var _this = this;
        var url = this.urls.getDeleteNomineeURL(investorId);
        this.showLoader("Saving your details..");
        return this.http.delete(url, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Delete Segment
     * @param investorId passing investor id
     * @param hideLoader boolean loader
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.deleteSegments = function (investorId, hideLoader) {
        var _this = this;
        var url = this.urls.getDeleteSegmentURL(investorId);
        if (!hideLoader) {
            this.showLoader("Saving your details..");
        }
        return this.http.delete(url, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Migration document
     * @param sourceInvestor passing investor source
     * @param destinationInvestor getting destination of investor
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.migrateDocuments = function (sourceInvestor, destinationInvestor) {
        var _this = this;
        var url = this.urls.getMigrateDocURL(sourceInvestor, destinationInvestor);
        this.showLoader("Migrating documents..");
        return this.http.post(url, null, { headers: this.getHeaders(false, destinationInvestor) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Generate Form
     * @param esignConsent {Observable<any>} An observable that emits the server's response or an error.
     * @param investorId passing investor id
     * @param isAccountClosure boolean account closuere
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.generateForms = function (esignConsent, investorId, isAccountClosure) {
        var _this = this;
        var url = this.urls.getGenerateFormsURL(esignConsent) + (isAccountClosure ? '&isAccountClosure=true' : '');
        this.showLoader("Generating forms..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * through leader getting investor detail
     * @param leadId passing lead id
     * @param dontInitializeLoader loader
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getInvestorByLeadId = function (leadId, dontInitializeLoader) {
        var _this = this;
        var url = this.urls.getInvestorByLeadIdURL(leadId);
        if (!dontInitializeLoader)
            this.showLoader("Fetching details..");
        return this.http.get(url, { headers: this.getHeaders(false, leadId) }).pipe(map(function (response) {
            if (!dontInitializeLoader)
                _this.hideLoader();
            return response;
        }), catchError(function (error) {
            if (!dontInitializeLoader)
                _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Sending onboarding otp
     * @param payload passing payload
     * @param isAlphabee boolean alphabee
     * @param investorId  passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.sendOnboardOTP = function (payload, isAlphabee, investorId) {
        var _this = this;
        var url = this.urls.getSendOnboardOTPURL();
        this.showLoader("Sending OTP..");
        return this.http.post(url, payload, { headers: this.getHeadersForOtp(isAlphabee, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * verify onbopardinng otp
     * @param payload passing payload
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.verifyOnboardOTP = function (payload, investorId) {
        var _this = this;
        var url = this.urls.getVerifyOnboardOTPURL();
        this.showLoader("Verifying OTP..");
        return this.http.post(url, payload, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Brokerage by refer code
     * @param referCode passing refer code
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getBrokerageByReferCode = function (referCode, investorId) {
        var _this = this;
        var url = this.urls.getBrokerageByReferCodeURL(referCode);
        this.showLoader("Getting brokerage..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * get document base url
     * @param investorId passing investor id
     * @param filePath passing file path
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getDocBaseURL = function (investorId, filePath) {
        var url = this.urls.getDocBaseURL(investorId, filePath);
        return url ? url + ('?q=' + new Date().valueOf()) : url;
    };
    /**
     * generate form url
     * @param fileName getting file name
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getGeneratedFormURL = function (fileName) {
        return this.urls.getGeneratedFormURL(fileName);
    };
    /**
     * getting brokerage data
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getBrokerageData = function () {
        var _this = this;
        var url = this.urls.getBrokerageDataURL();
        this.showLoader("Getting brokerage data..");
        return this.http.get(url).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching Brokerage
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getBUBrokerage = function () {
        var _this = this;
        var url = this.urls.getBUBrokerageDataURL();
        this.showLoader("Getting brokerage..");
        return this.http.get(url).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * get penny drop header
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getPennyDropHeaders = function () {
        var headers = new HttpHeaders({
            'Accept': 'application/json',
            'x-api-key': environment.xapiKeys.commonKey,
        });
        return headers;
    };
    /**
     * verifying penny drop count
     * @param request passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.verifyPennyDropAccount = function (request) {
        var _this = this;
        var url = this.urls.getpennyDropURL();
        this.showLoader("Verifying your Bank details...");
        return this.http.post(url, request, { headers: this.getPennyDropHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * recovering Client
     * @param pan passing pan number
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.recoverClient = function (pan, investorId) {
        var _this = this;
        var url = this.urls.getRecoverClientURL(pan);
        this.showLoader("Recovering client..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * respond Issue
     * @param request passing payload
     * @param source passing source
     * @param investorId investorId
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.respondIssue = function (request, source, investorId) {
        var _this = this;
        var url = this.urls.getRespondIssueURL(source);
        this.showLoader("Responding to an issue..");
        return this.http.post(url, request, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Location Detail
     * @param latlng location wise language
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getLocationDetail = function (latlng, investorId) {
        var _this = this;
        var url = this.urls.getLocationURL(latlng);
        this.showLoader("Getting location detail..");
        return this.http.get(url).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * language data
     * @param lang  pass language
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getLanguageData = function (lang) {
        var _this = this;
        var url = this.urls.getLangDataURL(lang);
        this.showLoader("Getting langauage data..");
        return this.http.get(url).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * get header
     * @param isMultipart isMultipart
     * @param investorId investorId
     * @param businessUnit businessUnit
     * @param isBlank isBlank
     * @param contactUpdationType contactUpdationType
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getHeaders = function (isMultipart, investorId, businessUnit, isBlank, contactUpdationType) {
        businessUnit = businessUnit || this.urls.getBusinessUnit();
        /** header */
        var headers;
        if (sessionStorage.getItem('ModifyFiles')) {
            headers = new HttpHeaders({
                'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
                'userid': 'Onboarding',
                'investorid': investorId || '',
                'businessunit': businessUnit || '',
                'from': (location.href || '') + '_' + (this.urls.version || ''),
                'Accept': 'application/json',
                "modificationType": sessionStorage.getItem('ModifyFiles')
            });
        }
        else {
            headers = new HttpHeaders({
                'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
                'userid': 'Onboarding',
                'investorid': investorId || '',
                'businessunit': businessUnit || '',
                'from': (location.href || '') + '_' + (this.urls.version || ''),
                'Accept': 'application/json',
            });
        }
        if (!isBlank) {
            headers.set('Content-Type', isMultipart ? 'multipart/form-data' : 'application/json');
        }
        if (contactUpdationType) {
            headers.set('contactUpdationType', contactUpdationType);
        }
        return headers;
    };
    /**
     * duplicate lead
     * @param request passing payload
     * @param id passing id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.updateDuplicateLeadAgainstPanNum = function (request, id) {
        var _this = this;
        var url = this.urls.getupdateDuplicateLidAgainstPanURL();
        this.showLoader("Saving your details..");
        return this.http.post(url, request, { headers: this.getHeaders(false, id) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * getting referal id
     * @param id passing id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getReferralDetails = function (id) {
        var _this = this;
        var url = this.urls.getreferralDetailsURL(id);
        this.showLoader("Getting referral detail..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching header got otp
     * @param isAlphabee boolean value for isalphabee
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getHeadersForOtp = function (isAlphabee, investorId) {
        var businessUnit = this.urls.getBusinessUnit();
        var headers;
        if (isAlphabee) {
            headers = new HttpHeaders({
                'ticket': this.urls.getAuthorizationHeader() || '',
                'userid': 'Onboarding',
                'investorid': investorId || '',
                'businessunit': businessUnit || '',
                'from': (location.href || '') + '_' + (this.urls.version || ''),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'originalSource': 'ALPHABEE'
            });
        }
        else {
            headers = new HttpHeaders({
                'ticket': this.urls.getAuthorizationHeader() || '',
                'userid': 'Onboarding',
                'investorid': investorId || '',
                'businessunit': businessUnit || '',
                'from': (location.href || '') + '_' + (this.urls.version || ''),
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            });
        }
        return headers;
    };
    /**
     * fetching bank detail;
     * @param request passing payload
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.bankBazaarUpdateDetails = function (request, investorId) {
        var _this = this;
        var url = this.urls.getBankBazaarUpdateDetailsURL();
        this.showLoader("Getting bank bazaar detail..");
        return this.http.post(url, request, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * upload bank document
     * @param formData passing formdaata
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.uploadBankBazaarDocs = function (formData, investorId) {
        var _this = this;
        var url = this.urls.getBankBazaarUploadDocsURL();
        this.showLoader("Upload bank bazaar documents..");
        return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * delete new lead againt pan
     * @param request passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.deleteNewLeadAgainstPanNum = function (request) {
        var _this = this;
        var url = this.urls.getdeletNewLeadAgainstPanURL();
        this.showLoader("Saving your details..");
        return this.http.post(url, request, { headers: this.getHeaders(false) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching digio document upload
     * @param investorId passing investor id
     * @param formName passing form name
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.digioDocUpload = function (investorId, formName) {
        var _this = this;
        var url = this.urls.getDigioDocUploadUrl();
        url = url.replace('$formName', formName);
        this.showLoader("Fetching Document ID..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * identify unique email or mobile
     * @param request passing payload
     * @param id passing id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.checkUniqueMobileAndEmail = function (request, id) {
        var _this = this;
        var url = this.urls.getUniqueCheckURL();
        this.showLoader("Checking your details..");
        return this.http.post(url, request, { headers: this.getHeaders(false, id, 'JF') }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Digio Document Download
     * @param investorId passing investor id
     * @param pan passing pan
     * @param docId passing document id
     * @param formName passing form name
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.digioDocDownload = function (investorId, pan, docId, formName) {
        var _this = this;
        var url = this.urls.getDigioDocDownloadUrl(pan, docId, formName);
        this.showLoader("Esign in progress..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * generate onboarding base url
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getOnboardingBaseURL = function () {
        return location.origin;
    };
    /**
     * fetching IPV sms
     * @param request passing payload
     * @param id passing id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.sendIPVSMS = function (request, id) {
        var _this = this;
        var url = this.urls.geIPVSmsURL();
        this.showLoader("Sending IPV link..");
        return this.http.post(url, request, { headers: this.getHeaders(false, id) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * header for kyc
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getKYCHeaders = function () {
        var headers = new HttpHeaders({
            'x-api-key': environment.xapiKeys.commonKey
        });
        return headers;
    };
    /**
     * Generate KYC
     * @param request passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.generateKYC = function (request) {
        var _this = this;
        var url = this.urls.getGenerateKYCURL();
        this.kycLoader = true;
        this.showLoader("Generating KYC...");
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.kycLoader = false;
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.kycLoader = false;
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * kyc saved
     * @param request passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.saveKYC = function (request) {
        var _this = this;
        var url = this.urls.getSaveKYCURL();
        this.showLoader("Saving KYC Details..");
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching environment type
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getEnvironmentType = function () {
        return this.urls.getEnvironment();
    };
    /**
     * fetching investor detail by pan
     * @param value passing form value
     * @param businessInfo passing bussiness
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getInvestorByPanOrClient = function (value, businessInfo) {
        var _this = this;
        var url = this.urls.getInvestorByPanClientURL(value, businessInfo);
        this.showLoader("Fetching details..");
        return this.http.get(url, { headers: this.getHeaders(false, "1", businessInfo) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * send otp
     * @param bu passing business unit
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.sendOTPRespond = function (investorId, bu) {
        var _this = this;
        // investorId, purpose
        var url = this.urls.getSendRespondOTPURL();
        this.showLoader("Sending OTP..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId, bu) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * validate otp
     * @param investorId passing investor id
     * @param otp passing otp
     * @param bu passing businessunit
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.verifyOTP = function (investorId, otp, bu) {
        var _this = this;
        var url = this.urls.getVerifyRespondOTPURL(otp);
        this.showLoader("Verifying OTP..");
        return this.http.get(url, { headers: this.getHeaders(false, investorId, bu) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * validate refer id
     * @param referralCode passing refer id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.checkRefercodeValidation = function (referralCode) {
        var _this = this;
        var url = this.urls.getReferralValidationURL(referralCode);
        this.showLoader("Checking your details..");
        return this.http.get(url, { headers: this.getHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * upload Documnents
     * @param formData passing formdata
     * @param fileNames passing file name
     * @param documentTypes passing document type
     * @param investorId passing investor id
     * @param hideLoader loader check
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.uploadDocsOffline = function (formData, fileNames, documentTypes, investorId, hideLoader) {
        var _this = this;
        var url = this.urls.getUploadDocsURL(fileNames, documentTypes);
        if (!hideLoader) {
            this.showLoader("Documents are being uploaded .Please wait for some time till it process..");
        }
        return this.http.post(url, formData, { headers: this.getHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching check PanValidate KYC
     * @param request passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.checkPanValidateKYC = function (request) {
        var _this = this;
        var url = this.urls.getPanValidateKYCURL();
        this.showLoader("Checking PAN Details..");
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * conntact upgradation header
     * @param isMultipart boolean value pass
     * @param investorId passing investor id
     * @param businessUnit passing bussiness  unit
     * @param isBlank empty opr not
     * @param contactUpdationType  passing contact updation type
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getcontactUpdationTypeHeaders = function (isMultipart, investorId, businessUnit, isBlank, contactUpdationType) {
        businessUnit = businessUnit || this.urls.getBusinessUnit();
        var headers = new HttpHeaders({
            'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
            'userid': 'Onboarding',
            'investorid': investorId || '',
            'businessunit': businessUnit || '',
            'from': (location.href || '') + '_' + (this.urls.version || ''),
            'Accept': 'application/json',
            'contactUpdationType': contactUpdationType || 'both'
        });
        if (!isBlank) {
            headers.set('Content-Type', isMultipart ? 'multipart/form-data' : 'application/json');
        }
        return headers;
    };
    /**
     * fetching education list
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveEducationListsV2 = function () {
        var _this = this;
        var url = this.urls.getEducationListV2URL();
        this.showLoader("Retrieving education list..");
        return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching check Unique  Mobile And Email Offline
     * @param request passing payload
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.checkUniqueMobileAndEmailOffline = function (request, investorId) {
        var _this = this;
        var url = this.urls.getUniqueCheckOfflineURL();
        this.showLoader("Checking your details..");
        return this.http.post(url, request, { headers: this.getHeaders(false, (investorId || '1'), 'JF') }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * header for adhaar masking
     * @param isMultipart boolean for is multi part
     * @param investorId passing investor id
     * @param businessUnit passing business unit
     * @param isBlank empty or not
     * @param contactUpdationType  passing contact Updation Type
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getmaskHeaders = function (isMultipart, investorId, businessUnit, isBlank, contactUpdationType) {
        businessUnit = businessUnit || this.urls.getBusinessUnit();
        var headers = new HttpHeaders({
            'ticket': this.urls.getAuthorizationHeader(businessUnit) || '',
            'userid': 'Onboarding',
            'investorid': investorId || '',
            'businessunit': businessUnit || '',
            'from': (location.href || '') + '_' + (this.urls.version || ''),
            'Accept': 'application/json',
            'x-api-key': environment.xapiKeys.commonKey
        });
        if (!isBlank) {
            headers.set('Content-Type', isMultipart ? 'multipart/form-data' : 'application/json');
        }
        if (contactUpdationType) {
            headers.set('contactUpdationType', contactUpdationType);
        }
        return headers;
    };
    /**
     * adhaar masking check
     * @param formDatamasking passing form Data masking
     * @param fileNames passing file Names
     * @param documentTypes passing document Types
     * @param investorId passing investor Id
     * @param hideLoader passing loader
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.maskingAdhaar = function (formDatamasking, fileNames, documentTypes, investorId, hideLoader) {
        var _this = this;
        var url = this.urls.getAdhaarMasking();
        if (!hideLoader) {
            this.showLoader("Uploading documents..");
        }
        return this.http.post(url, formDatamasking, { headers: this.getmaskHeaders(true, investorId) }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching state list
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveStateListsV2 = function () {
        var url = this.urls.getStatesListURLV2();
        this.showLoader("Retrieving state list..");
        return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            // this.hideLoader(); 
            return response;
        }), catchError(function (error) {
            // this.hideLoader(); 
            return throwError(error);
        }));
    };
    /**
     * fetching access token
     * @param data passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getAccessTokenURL = function (data) {
        var _this = this;
        var url = this.urls.generateAccessTokenURL();
        this.showLoader("Generating Access Token..");
        return this.http.post(url, data, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            console.log('inside success');
            return response;
        }), catchError(function (error) {
            console.log('inside error');
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * validation
     * @param data passing payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.retrieveValidationURL = function (data) {
        var _this = this;
        var url = this.urls.getValidationURL();
        this.showLoader("Validating Data..");
        return this.http.post(url, data, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * checking signature
     * @param data sign payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.checkSignatureOcrURL = function (data) {
        var _this = this;
        var url = this.urls.getSignatureOcrURL();
        this.showLoader("Loading Data..");
        return this.http.post(url, data, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching secure file
     * @param data passling payload
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getSecureFileDownload = function (data) {
        var _this = this;
        var url = this.urls.getSecureFileDownloadURL();
        var headers = this.getKYCHeaders();
        headers['Content-Type'] = 'application/json',
            headers['Accept'] = 'application/json';
        this.showLoader("Loading Data..");
        return this.http.post(url, data, { headers: headers, responseType: 'blob' })
            .pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * Update  InvestorDP Preference
     * @param data  passing paYLOAD
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getUpdateInvestorDPPreference = function (data) {
        var _this = this;
        var url = this.urls.getUpdateDPPreferenceURL();
        this.showLoader("Loading Data..");
        return this.http.post(url, data, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * get Setter Investor DP Preference
     * @param investorId passing investor id
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getSetterInvestorDPPreference = function (investorId) {
        var _this = this;
        var url = this.urls.getSetterDPPreferenceURL(investorId);
        this.showLoader("Loading Data..");
        return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching bank
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.getAllBanksWithLogo = function () {
        var _this = this;
        var url = this.urls.getAllBanksURL();
        this.showLoader("Loading Data..");
        return this.http.get(url, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * fetching digio event log
     * @param request passing digio event log
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.digioEventsLog = function (request) {
        var _this = this;
        var url = this.urls.getDigioEventsUrl();
        // this.showLoader("Saving KYC Details.."); 
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /**
     * validate email
     * @param request passing email
     * @returns {Observable<any>} An observable that emits the server's response or an error.
     */
    OnboardingService.prototype.ValidateEmail = function (request) {
        var _this = this;
        var url = this.urls.getValidateEmail();
        this.showLoader("Loading Data..");
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    /** Account Aggregator  generate link API*/
    OnboardingService.prototype.GenerateLink = function (request) {
        var _this = this;
        var url = this.urls.generateRequest();
        this.showLoader("Loading Data .. ");
        return this.http.post(url, request, { headers: this.getKYCHeaders() }).pipe(map(function (response) {
            _this.hideLoader();
            return response;
        }), catchError(function (error) {
            _this.hideLoader();
            return throwError(error);
        }));
    };
    OnboardingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OnboardingService_Factory() { return new OnboardingService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.APIURLs), i0.ɵɵinject(i3.SharedService)); }, token: OnboardingService, providedIn: "root" });
    return OnboardingService;
}());
export { OnboardingService };
